import checkEntityArray from './checkEntityArray';

export default function assignPayAction(basicEntity: any, potentialActionBlob: any) {
    const potentialAction = checkEntityArray(potentialActionBlob);

    return basicEntity && potentialAction
        ? {
              ...basicEntity,
              ...{
                  url: potentialAction.url,
                  description: potentialAction.description,
              },
          }
        : null;
}
